import ManageEventPosts from "./ManageEventPosts";
export default ManageEventPosts;
